import { useSelector } from "react-redux";
import { Post } from "../AxiosFunctions";
import { apiHeader, BaseURL } from "../config";
const useApi = () => {
  const {
    auth: { token },
  } = useSelector((state) => state);
  console.log("state", token);
  const login = (params) => Post(BaseURL("auth/login"), params);
  const getBookingsAdmin = (params) =>
    Post(BaseURL("booking/get-bookings-admin"), params, apiHeader(token));
  const addBooking = (params) =>
    Post(BaseURL("booking/add-booking-admin"), params, apiHeader(token));
  const updateProfile = (params) =>
    Post(BaseURL("profile/update-profile"), params, apiHeader(token));

  const forgotPassword = async (params) =>
    Post(BaseURL("auth/generate-otp-forgot"), params);

  const verifyOtp = async (params) =>
    Post(BaseURL("auth/verify-otp"), params, apiHeader(token));
  const passwordReset = async (params) =>
    Post(BaseURL("auth/forgot-password"), params, apiHeader(token));
  /* === locations === */

  const getAdminLocations = (params) =>
    Post(BaseURL("location/get-admin-locations"), params, apiHeader(token));
  const addLocation = (params) =>
    Post(BaseURL("location/add-location"), params, apiHeader(token));
  const updateLocation = (params) =>
    Post(BaseURL("location/update-location"), params, apiHeader(token));

  const getCourts = (params) =>
    Post(BaseURL("court/get-courts"), params, apiHeader(token));

  const getAllBlockedSlots = (params) =>
    Post(BaseURL("booking/get-blocked-times-admin"), params, apiHeader(token));
  const getLocations = (params) =>
    Post(BaseURL("location/get-locations-new"), params, apiHeader(token));
  const refundAndCancel = (params) =>
    Post(BaseURL("booking/refund-close-booking"), params, apiHeader(token));
  const paymentReceive = (params) =>
    Post(BaseURL("booking/receive-payment"), params, apiHeader(token));
  const getAllPayments = (params) =>
    Post(BaseURL("booking/get-payments-admin"), params, apiHeader(token));
  const confirmBooking = (params) =>
    Post(BaseURL("booking/confirm-booking"), params, apiHeader(token));

  const getAllCourts = (params) =>
    Post(BaseURL("court/get-courts"), params, apiHeader(token));

  const addCourt = (params) =>
    Post(BaseURL("court/add-court"), params, apiHeader(token));

  const addCourtTiming = (params) =>
    Post(BaseURL("court/add-court-timing"), params, apiHeader(token));
  const updateCourt = (params) =>
    Post(BaseURL("court/update-court"), params, apiHeader(token));

  const deleteCourtTiming = (params) =>
    Post(BaseURL("court/delete-court-timing"), params, apiHeader(token));

  const deleteCourt = (params) =>
    Post(BaseURL("court/delete-court"), params, apiHeader(token));

  const addCorporate = (params) =>
    Post(BaseURL("corporate/add-corporate"), params, apiHeader(token));
  const updateCorporate = (params) =>
    Post(BaseURL("corporate/update-corporate"), params, apiHeader(token));
  const getAllCorporates = (params) =>
    Post(BaseURL("corporate/get-corporates"), params, apiHeader(token));
  const getAllCoupons = (params) =>
    Post(BaseURL("coupon/get-coupons"), params, apiHeader(token));
  const addCoupon = (params) =>
    Post(BaseURL("coupon/add-coupon"), params, apiHeader(token));
  const updateCoupon = (params) =>
    Post(BaseURL("coupon/update-coupon"), params, apiHeader(token));

  const addCorporateCoupon = (params) =>
    Post(BaseURL("corporate/add-corporate-coupon"), params, apiHeader(token));

  const getUserByName = (params) =>
    Post(BaseURL("user/get-users-by-name"), params, apiHeader(token));

  const addAnnouncement = (params) =>
    Post(BaseURL("notification/add-announcement"), params, apiHeader(token));

  const getAnnouncements = (params) =>
    Post(BaseURL("notification/get-announcements"), params, apiHeader(token));

  const getNotifications = (params) =>
    Post(BaseURL("notification/get-notifications"), params, apiHeader(token));

  const deleteAnnouncement = (params) =>
    Post(BaseURL("court/delete-court-timing"), params, apiHeader(token));

  const addImages = (params) =>
    Post(BaseURL("image/add-image"), params, apiHeader(token));

  const updateImages = (params) =>
    Post(BaseURL("image/update-image"), params, apiHeader(token));

  const getUsers = (params) =>
    Post(BaseURL("user/get-users"), params, apiHeader(token));

  const getUserStats = (params) =>
    Post(BaseURL("user/get-users-stats"), params, apiHeader(token));
  const getPaymentStats = (params) =>
    Post(BaseURL("booking/get-payment-stats"), params, apiHeader(token));
  const getBannerImage = (params) =>
    Post(BaseURL("auth/get-home-data"), params, apiHeader(token));

  const getDashboardStats = (params) =>
    Post(BaseURL("dashboard/get-dashboard-stats"), params, apiHeader(token));

  const rescheduleBooking = (params) =>
    Post(BaseURL("booking/reschedule-booking-admin"), params, apiHeader(token));
  const logoutApi = (params) =>
    Post(BaseURL("auth/logout"), params, apiHeader(token));


  const bookingCompleted =params =>Post(BaseURL("booking/completed-booking"),params,apiHeader(token))
  return {
    login,
    getBookingsAdmin,
    updateProfile,
    forgotPassword,
    verifyOtp,
    // locations
    getAdminLocations,
    addLocation,
    updateLocation,
    getCourts,
    addCourtTiming,
    passwordReset,
    getAllBlockedSlots,
    getLocations,
    addBooking,
    refundAndCancel,
    paymentReceive,
    getAllPayments,
    confirmBooking,

    getAllCourts,
    addCourt,

    deleteCourtTiming,
    updateCourt,
    /***/
    addCorporate,
    getAllCorporates,
    getAllCoupons,
    addCoupon,
    updateCoupon,
    addCorporateCoupon,
    updateCorporate,
    getUserByName,
    addAnnouncement,
    getAnnouncements,
    getNotifications,
    deleteAnnouncement,
    addImages,
    updateImages,
    getUsers,
    getUserStats,
    getBannerImage,
    getPaymentStats,
    getDashboardStats,
    rescheduleBooking,
    logoutApi
,
bookingCompleted 
};
};

export default useApi;
